import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';

const LOCAL_KEY = 'commercialVehicle';

@Module({namespaced: true, stateFactory: true})
export default class SettingsModule extends VuexModule {
  commercialVehicle = false;

  @Mutation
  setCommercialVehicle(commercialVehicle) {
    this.commercialVehicle = commercialVehicle;

    localStorage.setItem(LOCAL_KEY, commercialVehicle);
  }

  @Action
  initializeState() {
    if (localStorage.getItem(LOCAL_KEY)) {
      this.context.commit('setCommercialVehicle', localStorage.getItem(LOCAL_KEY))
    }
  }
}
